import { render, staticRenderFns } from "./GroupDetailCourse.vue?vue&type=template&id=6c019382&scoped=true"
import script from "./GroupDetailCourse.vue?vue&type=script&lang=js"
export * from "./GroupDetailCourse.vue?vue&type=script&lang=js"
import style0 from "./GroupDetailCourse.vue?vue&type=style&index=0&id=6c019382&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c019382",
  null
  
)

export default component.exports